export default __webpack_public_path__ + "static/media/1.c34434d3.jpg";